import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { MortgageProgress, Mortgage } from '@app/core/stingray-api/models';
import { UntypedFormGroup, UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MortgagesService } from '@app/core/stingray-api/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import moment from 'moment';
import { finalize } from 'rxjs/operators';
import { MortgageService } from '@app/customer/mortgages/mortgage.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DecimalPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormField } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';

@Component({
    selector: 'unite-mortgage-progress',
    templateUrl: './mortgage-progress.component.html',
    styleUrls: ['./mortgage-progress.component.scss'],
    imports: [MatCard, MatCardHeader, MatCardTitle, TranslateModule, MatCardContent, ReactiveFormsModule, MatFormField, MatSelect, MatOption, MatRadioGroup, MatRadioButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatProgressSpinner, DecimalPipe, CurrencyPipe, DatePipe]
})
export class MortgageProgressComponent implements OnInit {

  private destroyRef = inject(DestroyRef);
  mortgage: Mortgage;

  isLoadingMortgageProgress = false;
  mortgageProgressesData: MortgageProgress[] = null;
  mortgageProgressesDisplayedColumns: string[] = ['date', 'interest', 'repayment', 'remainingLoan', 'loanToValue', 'total'];
  mortgageProgressesFilter: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private mortgageService: MortgageService,
    private mortgagesService: MortgagesService) {

    this.mortgageProgressesFilter = this.formBuilder.group({
      duration: ['10'],
      scale: ['year'],
    });
  }

  ngOnInit() {
    this.mortgageService.getMortgage().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((mortgage: Mortgage) => {
      this.mortgage = mortgage;

      this.loadMortgageProgress();
    });

    this.mortgageProgressesFilter.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.loadMortgageProgress();
    });
  }

  private loadMortgageProgress() {
    this.isLoadingMortgageProgress = true;
    this.mortgagesService.getMortgageProgressById({
      id: this.mortgage.id,
      starDate: (moment().locale('en').format('L')),
      endDate: (moment().add(this.mortgageProgressesFilter.get('duration').value, 'years').locale('en').format('L')),
      scale: this.mortgageProgressesFilter.get('scale').value
    }).pipe(finalize(() => this.isLoadingMortgageProgress = false)).subscribe((mortgageProgresses: MortgageProgress[]) => {
      this.mortgageProgressesData = mortgageProgresses;
    });
  }

}
